<script setup>
// Conversations by agent (live overview): every agent with their open and unattended conversations, most open first,
// then by name. The table itself is LiveConversationsTable (the kit's table, footer and remembered page size).
import { computed } from 'vue';
import LiveConversationsTable from './LiveConversationsTable.vue';

const props = defineProps({
  agents: {
    type: Array,
    default: () => [],
  },
  agentMetrics: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const getAgentMetrics = id =>
  props.agentMetrics.find(metrics => metrics.assignee_id === Number(id)) || {};

const rows = computed(() =>
  props.agents
    .map(agent => {
      const metric = getAgentMetrics(agent.id);
      return {
        id: agent.id,
        name: agent.available_name || agent.name,
        email: agent.email,
        thumbnail: agent.thumbnail,
        status: agent.availability_status,
        open: metric.open || 0,
        unattended: metric.unattended || 0,
      };
    })
    .sort((a, b) => b.open - a.open || a.name.localeCompare(b.name))
);
</script>

<template>
  <LiveConversationsTable
    :rows="rows"
    people
    :is-loading="isLoading"
    :name-header="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.TABLE_HEADER.AGENT')"
    page-size-key="report_overview_agent_table_page_size"
    count-key="POLARIS_REPORTS.LIVE_TABLE.AGENTS_COUNT"
    showing-key="POLARIS_REPORTS.LIVE_TABLE.AGENTS_SHOWING"
    :empty-text="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.NO_AGENTS')"
  />
</template>
